var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#eef1f3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2916 16C22.5383 16 21.1458 17.3933 21.1458 19.0767C21.1458 20.7601 22.5383 22.1534 24.2916 22.1534C26.0449 22.1534 27.4374 20.7601 27.4374 19.0767C27.4374 17.3933 26.0449 16 24.2916 16ZM19.1458 19.0767C19.1458 16.2571 21.4656 14 24.2916 14C27.1176 14 29.4374 16.2571 29.4374 19.0767C29.4374 21.8963 27.1176 24.1534 24.2916 24.1534C21.4656 24.1534 19.1458 21.8963 19.1458 19.0767ZM15 31.3068C15 28.4873 17.3198 26.2301 20.1458 26.2301H28.4374C31.2634 26.2301 33.5832 28.4873 33.5832 31.3068V33.3452C33.5832 33.8975 33.1355 34.3452 32.5832 34.3452C32.0309 34.3452 31.5832 33.8975 31.5832 33.3452V31.3068C31.5832 29.6234 30.1907 28.2301 28.4374 28.2301H20.1458C18.3925 28.2301 17 29.6234 17 31.3068V33.3452C17 33.8975 16.5523 34.3452 16 34.3452C15.4477 34.3452 15 33.8975 15 33.3452V31.3068Z",
    fill: "#42515A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.315ff67c7dae04ff4826ada6633caac7.svg";
export { ForwardRef as ReactComponent };